/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
// import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import {
  getUserByToken,
  login
} from '../core/_requests'
// import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useAuth } from '../core/Auth'
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl'
// import { Link } from 'react-router-dom'


const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState<boolean>(false)
  const { saveAuth, setCurrentUser } = useAuth()
  const intl = useIntl()

  const loginSchema = Yup.object().shape({
    email: Yup.string()
      .email({ message: intl.formatMessage({ id: 'VALIDATE_ERROR.INVALID_EMAIL_FORMAT' }) })
      .min(3, { message: intl.formatMessage({ id: 'VALIDATE_ERROR.MIN_3_SYMBOLS' }) })
      .max(50, { message: intl.formatMessage({ id: 'VALIDATE_ERROR.MAX_50_SYMBOLS' }) })
      .required({ message: intl.formatMessage({ id: 'VALIDATE_ERROR.EMAIL_REQUIRED' }) }),
    password: Yup.string()
      .min(3, { message: intl.formatMessage({ id: 'VALIDATE_ERROR.MIN_3_SYMBOLS' }) })
      .max(50, { message: intl.formatMessage({ id: 'VALIDATE_ERROR.MAX_50_SYMBOLS' }) })
      .required({ message: intl.formatMessage({ id: 'VALIDATE_ERROR.PASSWORD_REQUIRED' }) }),
  })
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        // Save Auth
        const { data: loginResult } = await login(values.email, values.password)
        saveAuth({ accessToken: loginResult.results?.access, refreshToken: loginResult.results?.root })

        // Save User
        const { data: userResult } = await getUserByToken()
        setCurrentUser(userResult.results)
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus(intl.formatMessage({ id: 'MESSAGE.INVALID_LOGIN' }))
        setSubmitting(false)
        setLoading(false)
      }
    },
  });

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>CBP Portal</h1>
      </div>
      {/* begin::Heading */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark'>{intl.formatMessage({ id: 'LOGIN.EMAIL' })}</label>
        <input
          placeholder={intl.formatMessage({ id: 'LOGIN.EMAIL' })}
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid'
          )}
          type='email'
          name='email'
          autoComplete='off'
        />
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='d-flex justify-content-between mt-n5'>
          <div className='d-flex flex-stack mb-2'>
            {/* begin::Label */}
            <label className='form-label fw-bolder text-dark fs-6 mb-0'>{intl.formatMessage({ id: 'LOGIN.PASSWORD' })}</label>
            {/* end::Label */}
          </div>
          <div>
            {/* begin::Link */}
            <Link
              to='/auth/forgot-password'
              className='link-primary fs-6 fw-bolder'
              style={{ marginLeft: '5px' }}
              tabIndex={-1}
            >
              {intl.formatMessage({ id: 'LOGIN.FORGOT_PASSWORD' })}
            </Link>
            {/* end::Link */}
          </div>
        </div>
        <input
          placeholder={intl.formatMessage({ id: 'LOGIN.PASSWORD' })}
          type='password'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
          )}
        />
        {/* Error Message */}
        {formik.status && (
          <div className='fv-plugins-message-container text-danger'>
            <span role='alert'>{formik.status}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>{intl.formatMessage({ id: 'LOGIN.LOGIN' })}</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              {intl.formatMessage({ id: 'COMMON.PLEASE_WAIT' })}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}
    </form>
  )
}
